import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,{class:_vm.$style.legsBlockBtn,attrs:{"outlined":"","block":"","loading":_vm.loading,"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }